import {
  Show,
  SimpleShowLayout,
  ArrayField,
  Datagrid,
  TextField,
  useRecordContext,
} from 'react-admin'
import { TableHead, TableRow, TableCell } from '@mui/material'

import {
  Grid,
  Button,
  ButtonGroup,
  makeStyles,
  DialogTitle,
  DialogContent,
} from '@material-ui/core'
import { Visibility as VisibilityIcon, ArrowBack } from '@mui/icons-material'

import { buildUrl, buildFilename } from './utils'
import Pill from './components/pill'
import { PreviewButton } from './components/file_upload'

const useStyles = makeStyles({
  fileButtons: {
    textTransform: 'none',
  },
})

const CustomFileField = (props) => {
  const classes = useStyles()
  const record = useRecordContext(props)

  return (
    <ButtonGroup
      disableElevation
      variant="contained"
      color="primary"
      size="small"
    >
      {record.devis.map((devisUrl) => {
        if (!devisUrl) return null

        return (
          <Button
            key={devisUrl}
            startIcon={<VisibilityIcon />}
            href={buildUrl(devisUrl)}
            className={classes.fileButtons}
          >
            {buildFilename(devisUrl)}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

const CustomAmountField = (props) => {
  const record = useRecordContext(props)

  return <Pill id={record.id} value={`€${record.amount}`} status="success" />
}

const DatagridHeader = ({ children }) => (
  <TableHead>
    <TableRow>
      {children.map((child) => (
        <TableCell
          key={child.props.source}
          style={{
            textAlign: child.props.source === 'url' ? 'center' : 'left',
          }}
        >
          {child.props.label || child.props.source}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
)

export const MecArrayField = (props) => {
  const record = useRecordContext(props)

  // @todo: Ask for what value we should show on "Date"
  return (
    <>
      <DialogTitle>
        <Grid container>
          <Grid item xs={12}>
            Mises en concurrence
          </Grid>
          <Grid item xs={11}>
            {record.libelle}
          </Grid>
          <Grid item xs={1}>
            <Button style={{ marginLeft: '-1rem' }} onClick={props.onBackClick}>
              <ArrowBack />
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: '12px',
            }}
          >
            Vous trouverez ci-dessous les devis disponibles pour cette mise en
            concurrence.
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <ArrayField label="Propositions" source="mec_data" record={record}>
          <Datagrid bulkActionButtons={false} header={<DatagridHeader />}>
            <TextField source="provider_name" label="Prestataire" />
            <CustomAmountField source="amount" label="Montant" />
            <PreviewButton
              source="url"
              label="Devis"
              style={{ textAlign: 'center' }}
            />
          </Datagrid>
        </ArrayField>
      </DialogContent>
    </>
  )
}

export const Mec = (props) => {
  return (
    <Grid container justify="center">
      <Grid item xs={12} md={8}>
        <Show {...props}>
          <SimpleShowLayout>
            <MecArrayField />
          </SimpleShowLayout>
        </Show>
      </Grid>
    </Grid>
  )
}
